import dynamic from 'next/dynamic'

import Text from '@ilg-totallymoney/ui/components/Text'

const DynamicUnscoredFrequentlyAskedQuestions = dynamic(
    () => import('./UnscoredFrequentlyAskedQuestions'),
    {
        loading: () => <Text>Loading...</Text>,
    }
)

export default DynamicUnscoredFrequentlyAskedQuestions
